<app-header>
    <jbm-view-title [caption]="'users.title'|translate"
      [parentLinkCaption]="'menu.settings'|translate"
      [parentLinkSlug]="'settings'"></jbm-view-title>
    <div class="btn-group float-end">
        <jbm-help-button [helpTopicID]="0"></jbm-help-button>
    </div>
</app-header>
<section class="module padding">
    <nav ngbNav #nav="ngbNav" [(activeId)]="active" class="nav-tabs module bg-light">
        <ng-container ngbNavItem [ngbNavItem]="0">
            <a ngbNavLink>{{'users.users'|translate}}</a>
            <ng-template ngbNavContent>
                <users></users>
            </ng-template>
        </ng-container>
        <ng-container ngbNavItem [ngbNavItem]="1">
            <a ngbNavLink>{{'users.usergroups'|translate}}</a>
            <ng-template ngbNavContent>
                <usergroups></usergroups>
            </ng-template>
        </ng-container>
        <ng-container ngbNavItem [ngbNavItem]="2">
            <a ngbNavLink>{{'users.grouprights'|translate}}</a>
            <ng-template ngbNavContent>
                <groupsrights></groupsrights>
            </ng-template>
        </ng-container>
    </nav>
    <div [ngbNavOutlet]="nav" class="mt-2"></div>
</section>
